import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Alert } from '@sainsburys-tech/bolt';
import { ImageAndTable } from './imageAndTable/ImageAndTable';
import populateTables from '../../helpers/populateTables';
import { getImages } from '../../helpers/getImages';
import * as Styled from './Dimensions.styles';

var Dimensions = function Dimensions(_ref) {
  var dimensions = _ref.dimensions,
      media = _ref.media;

  var _populateTables = populateTables(dimensions),
      _populateTables2 = _slicedToArray(_populateTables, 2),
      frontViewTable = _populateTables2[0],
      sideViewTable = _populateTables2[1];

  var _getImages = getImages(media),
      _getImages2 = _slicedToArray(_getImages, 2),
      frontImageURL = _getImages2[0],
      sideImageURL = _getImages2[1];

  var packageOneTitle = dimensions !== null && dimensions !== void 0 && dimensions.packageSizeTwo ? 'Package 1 - ' : 'Packaged - ';
  var packageTwoSize = dimensions !== null && dimensions !== void 0 && dimensions.packageSizeOne && dimensions !== null && dimensions !== void 0 && dimensions.packageSizeTwo ? dimensions === null || dimensions === void 0 ? void 0 : dimensions.packageSizeTwo : null;
  var sizeInfo = [{
    title: 'Assembled - ',
    value: (dimensions === null || dimensions === void 0 ? void 0 : dimensions.Dimensions) || (dimensions === null || dimensions === void 0 ? void 0 : dimensions.size)
  }, {
    title: packageOneTitle,
    value: dimensions === null || dimensions === void 0 ? void 0 : dimensions.packageSizeOne
  }, {
    title: 'Package 2 - ',
    value: packageTwoSize
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, sizeInfo.map(function (el) {
    if (!el.value) return null;
    return /*#__PURE__*/React.createElement(Styled.TextContainer, {
      key: el.title
    }, /*#__PURE__*/React.createElement("strong", null, el.title), el.value);
  }), /*#__PURE__*/React.createElement(Alert, {
    kind: "info",
    isCloseable: false
  }, "As these items are handmade, measurements can vary by 3-5cm so you need to account for that when measuring your item"), /*#__PURE__*/React.createElement(ImageAndTable, {
    heading: "Front View",
    imageURL: frontImageURL,
    tableData: frontViewTable
  }), /*#__PURE__*/React.createElement(ImageAndTable, {
    heading: "Side View",
    imageURL: sideImageURL,
    tableData: sideViewTable
  }));
};

export default Dimensions;